import { Controller } from "@hotwired/stimulus";
import { useOutlets } from "hb/insights/use_outlets";

export default class extends Controller {
  static targets = ["siteItem", "statusItem", "metric"];

  connect() {
    useOutlets(this);
  }
}
